<template>
    <div class="space-y-4">
        <div>
            <JetLabelRequired value="Action" />
            <select class="form-input w-full" :value="type" @change="changeType($event.target.value)">
                <option value="" disabled>Choisissez l'action à faire</option>
                <option v-for="action in actions" :key="action.value" :value="action.value">
                    {{ action.label }}
                </option>
            </select>

            <JetInputError :message="errors?.action_type" />
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div v-if="type && type !== 'none'">
                <JetLabelRequired value="Libellé bouton" />
                <JetInput
                    type="text"
                    :value="label ?? ''"
                    @input="$emit('update:label', $event.target.value)"
                    placeholder="Ex: Voir mon colis"
                />
                <JetInputError :message="errors?.action_label" />
            </div>
    
    
            <div v-if="type === 'package'">
                <JetLabelRequired value="Colis concerné" />
                <Multiselect
                    :options="packages"
                    :model-value="selectedPackageId"
                    value-prop="id"
                    label="label"
                    track-by="id"
                    placeholder="Sélectionner un colis"
                    :searchable="true"
                    :can-clear="true"
                    @update:model-value="selectPackage"
                />
                <JetInputError :message="actionableIdError" />
            </div>
    
            <div v-if="type === 'travel'">
                <JetLabelRequired value="Expédition concernée" />
                <Multiselect
                    :options="travels"
                    :model-value="selectedTravelId"
                    value-prop="id"
                    label="label"
                    track-by="id"
                    placeholder="Sélectionner une expédition"
                    :searchable="true"
                    :can-clear="true"
                    @update:model-value="selectTravel"
                />
                <JetInputError :message="actionableIdError" />
            </div>
    
            <div v-if="type === 'url'">
                <JetLabelRequired value="URL" />
                <JetInput
                    type="url"
                    placeholder="https://..."
                    :value="payload?.url ?? ''"
                    @input="updatePayload({url: $event.target.value})"
                />
                <JetInputError :message="errors?.['action_payload.url']" />
            </div>
    
            <div v-if="type === 'phone' || type === 'whatsapp'">
                <JetLabelRequired value="Téléphone" />
                <JetInput
                    type="tel"
                    placeholder="+225..."
                    :value="payload?.phone ?? ''"
                    @input="updatePayload({phone: $event.target.value})"
                />
                <JetInputError v-if="type === 'phone'" :message="errors?.['action_payload.phone']" />
            </div>
    
            <div v-if="type === 'screen'">
                <JetLabelRequired value="Route" />
                <JetInput
                    type="text"
                    :value="payload?.route ?? ''"
                    @input="updatePayload({route: $event.target.value})"
                    placeholder="/packages"
                />
                <JetInputError :message="errors?.['action_payload.route']" />
            </div>
        </div>
    </div>
</template>

<script>
    import JetInput from '@/Jetstream/Input'
    import Multiselect from '@vueform/multiselect'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabelRequired from '@/Jetstream/LabelRequired'

    export default {
        components: {
            JetInput,
            Multiselect,
            JetInputError,
            JetLabelRequired
        },

        emits: [
            'update:type',
            'update:label',
            'update:payload'
        ],

        props: {
            type: {
                type: String,
                default: null
            },

            label: {
                type: String,
                default: null
            },

            payload: {
                type: Object,
                default: () => ({})
            },

            actions: {
                type: Array,
                default: () => []
            },

            packages: {
                type: Array,
                default: () => []
            },

            travels: {
                type: Array,
                default: () => []
            },

            errors: {
                type: Object,
                default: () => ({})
            }
        },

        computed: {
            selectedPackageId() {
                if (this.payload?.actionable_type !== 'package') {
                    return null
                }

                return this.payload?.actionable_id ?? null
            },

            selectedTravelId() {
                if (this.payload?.actionable_type !== 'travel') {
                    return null
                }

                return this.payload?.actionable_id ?? null
            },

            actionableIdError() {
                return this.errors?.['action_payload.actionable_id'] ?? null
            }
        },

        methods: {
            changeType(value) {
                this.$emit('update:type', value)

                // On réinitialise le payload lorsque
                // le type d'action change.
                this.$emit('update:payload', {})

                if (value === 'none') {
                    emit("update:label", null);
                }
            },

            updatePayload(values) {
                this.$emit('update:payload', {
                    ...(this.payload ?? {}),
                    ...values
                })
            },

            selectPackage(id) {
                this.$emit('update:payload', {
                    ...(this.payload ?? {}),
                    actionable_type: 'package',
                    actionable_id: id
                })
            },

            selectTravel(id) {
                this.$emit('update:payload', {
                    ...(this.payload ?? {}),
                    actionable_type: 'travel',
                    actionable_id: id
                })
            }
        }
    }
</script>